import axios from "@/plugins/axios";

export default {
    getAll(filters) {
        return axios.get('api/panel/tratamientos/modales', { params: filters });
    },
    paginate(filters) {
        return axios.get('api/panel/tratamientos/modales/paginate', { params: filters });
    },
    store(data) {
        return axios.post('api/panel/tratamientos/modales', data);
    },
    update(id, data) {
        return axios.post(`api/panel/tratamientos/modales/${id}`, data);
    },
    destroy(id, data) {
        return axios.delete(`api/panel/tratamientos/modales/${id}`, data);
    },

}